import { Link } from 'react-router-dom';
import { featuredMatches } from '@/mocks/home';

const flagEmojiMap: Record<string, string> = {
  mx: '🇲🇽',
  us: '🇺🇸',
  ca: '🇨🇦',
  tbd: '🏳️',
};

const stageBadge: Record<string, string> = {
  '揭幕战': 'bg-primary-500/10 text-primary-400 border-primary-500/30',
  '小组赛': 'bg-accent-500/10 text-accent-400 border-accent-500/30',
};

export default function MatchSchedule() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            赛事日程
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-3">
            焦点赛事一览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            从揭幕战到决赛，精选不可错过的重磅对决
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredMatches.map((match) => (
            <div
              key={match.id}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-300/50 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <span
                  className={`px-2.5 py-1 rounded-full text-xs font-semibold border ${stageBadge[match.stage] || 'bg-background-100 text-foreground-600 border-background-200'}`}
                >
                  {match.stage}
                </span>
                <span className="text-xs text-foreground-500">
                  {match.date}
                </span>
              </div>

              <div className="flex items-center justify-between mb-3">
                <div className="flex flex-col items-center gap-2 flex-1">
                  <span className="text-3xl">{flagEmojiMap[match.homeFlag] || '🏳️'}</span>
                  <span className="font-heading font-semibold text-sm text-foreground-800 text-center">
                    {match.homeTeam}
                  </span>
                </div>

                <div className="flex flex-col items-center px-3">
                  <span className="font-heading font-bold text-xl text-foreground-400">VS</span>
                  <span className="text-xs text-foreground-500 mt-1">{match.time}</span>
                </div>

                <div className="flex flex-col items-center gap-2 flex-1">
                  <span className="text-3xl">{flagEmojiMap[match.awayFlag] || '🏳️'}</span>
                  <span className="font-heading font-semibold text-sm text-foreground-800 text-center">
                    {match.awayTeam}
                  </span>
                </div>
              </div>

              <div className="pt-3 border-t border-background-200">
                <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xs"></i>
                  </span>
                  {match.venue} · {match.city}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-full text-sm font-semibold transition-all duration-200 hover:bg-secondary-600 whitespace-nowrap cursor-pointer"
          >
            查看完整赛程
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}